import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import { FilterObj_Set, PickingHead_Set } from "./SlicePickingHead";
import moment from "moment";
import {
  fAlertToast,
  GetGitterColumns,
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
} from "../../Utility/Utilitys";
import Picking_Breadcrumbs from "./Picking_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { picking_PickingSumry_API } from "./../../Server/ApiV2";
import { CmpTextFieldEnter } from "./../../Component/Common/ToolBox/ToolBox";
import PickingSummaryModal from "./component/PickingSummaryModal";
import { PickingSummaryCard } from "./component/PickingSummaryCard";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import { Typography } from "@mui/material";
import CustomDatagrid from "../PromotionAutomation/Components/CustomDatagrid";

const columns = [
  {
    key: "A_VocTyp",
    header: "VocTyp",
    width: 60,
    sortable: true,
    filterable: true,
    hide: true,
    align: "left",
  },
  {
    key: "VocName",
    header: "Voc.Name",
    width: 120,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "A_VocNo",
    header: "Voc.No",
    width: 80,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "A_VocDt",
    header: "Date",
    width: 60,
    sortable: true,
    filterable: true,
    align: "left",
    render: (r) => (
      <Typography>
        {r.A_VocDt ? moment(r.A_VocDt).format("DD/MM/YYYY") : ""}
      </Typography>
    ),
  },
  {
    key: "LocName",
    header: "Location",
    width: 130,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "A_TransTypName",
    header: "Trans.Type",
    width: 150,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "ClusterName",
    header: "Cluster",
    width: 150,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "LDBAYName",
    header: "Loading.Bay",
    width: 130,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "A_Typ",
    header: "Type",
    width: 70,
    sortable: true,
    filterable: true,
    align: "left",
  },
  {
    key: "A_DocStat",
    header: "DocStat",
    width: 80,
    sortable: true,
    filterable: true,
    align: "left",
    render: (r) => {
      const style = getStatusStyleV1(r.A_DocStat);
      return (
        <div
          style={{
            ...style,
            padding: "2px 8px",
            borderRadius: "4px",
            textAlign: "center",
            width: "60%",
            fontWeight: "bold",
          }}
        >
          {r.A_DocStat}
        </div>
      );
    },
  },
  {
    key: "A_PKL_DocStatus",
    header: "Status",
    width: 80,
    sortable: true,
    filterable: true,
    align: "left",
    render: (r) => {
      const style = getStatusStyleV1(r.A_PKL_DocStatus);
      return (
        <div
          style={{
            ...style,
            padding: "2px 8px",
            borderRadius: "4px",
            textAlign: "center",
            width: "60%",
            fontWeight: "bold",
          }}
        >
          {r.A_PKL_DocStatus}
        </div>
      );
    },
  },
];

const visibleColumns = columns.filter((col) => col.key !== "A_VocTyp");

export default function PickingHead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxFilterObj = useSelector(
    (state) => state.SlicePickingHead.value.filterObj
  );
  const [sLocation, SetLocation] = useState(vRdxuserLoc);
  const statusData = [
    {
      id: "ENTER",
      statusName: "ENTER",
    },
    {
      id: "DELETE",
      statusName: "DELETE",
    },
    {
      id: "POST",
      statusName: "POST",
    },
  ];

  console.log("nj", vRdxFilterObj);

  const showPagination = false;
  const [sPackingGridRow, setPackingGridRow] = useState([]);
  const [sinstanceData, setInstanceData] = useState({
    loc: vRdxuserLoc[0]?.UID,
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: statusData[0].id,
    DocNo: "",
  });
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const fLoad = () => {
    GetInstancePickingData(
      vRdxFilterObj?.loc === "" ? vRdxuserLoc[0]?.UID : vRdxFilterObj?.loc,
      vRdxFilterObj?.dateFrom,
      vRdxFilterObj?.dateTo,
      vRdxFilterObj?.statusVal,
      vRdxFilterObj?.DocNo
    );
  };

  const GetInstancePickingData = useCallback(
    async (xLoc, xFromDate, xToDate, xStatus, xDocNo) => {
      var vPickingData = {
        v_Loc: xLoc,
        v_Date1: moment(xFromDate).format("MM/DD/YYYY"),
        v_Date2: moment(xToDate).format("MM/DD/YYYY"),
        v_Status: xStatus,
        v_VocNo: xDocNo,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vPickingData);
      const vSearch = await picking_PickingSumry_API(FinalObj);
      if (vSearch.status === 200) {
        if (vSearch?.data?.ResultSet.length > 0) {
          let iResp = vSearch?.data?.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
          setPackingGridRow(iResp);
          setShowModal(false);
        } else {
          setPackingGridRow([]);
          setShowModal(false);
        }
      }
    },
    []
  );

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState(columns);

  useEffect(() => {
    GetGitterColumns(setSummaryGridColumn2, "WMPKLSTGSUMWB", columns);
  }, []);

  useEffect(() => {
    fLoad();
  }, []);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-2">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Picking_Breadcrumbs />{" "}
        {vMediaQuery && (
          <CmpButton
            xbtnName="Filter"
            xOnClick={() => {
              setShowModal(true);
            }}
            xVariant="contained"
            xSize="small"
          />
        )}
      </div>
      <Box
        sx={{ margin: "auto", width: "100%", paddingX: "12px", paddingY: 1 }}
      >
        {!vMediaQuery && (
          <Grid container spacing={2} className="stock-detail">
            <Grid item lg={2.5} md={2.5} sm={5} xs={6}>
              <CmpSelectBox
                xref={LocationFocusOnLoad}
                xLabelText="Location"
                xValue={
                  vRdxFilterObj?.loc === ""
                    ? vRdxuserLoc[0]?.UID
                    : vRdxFilterObj?.loc
                }
                xOnChange={(e) => {
                  dispatch(
                    FilterObj_Set({
                      loc: e.target.value,
                    })
                  );
                }}
                xName={"loc"}
                xData={vRdxuserLoc}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={false}
                xDisable={false}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={1.8}
              sm={3.5}
              xs={6}
              className="bintransfer-data-date"
            >
              <CmpDatePicker
                xLabelText={"From Date"}
                xValue={vRdxFilterObj?.dateFrom}
                xOnChange={(newValue) => {
                  dispatch(
                    FilterObj_Set({
                      dateFrom: newValue.$d,
                    })
                  );
                }}
                xName={"dateFrom"}
                xError={false}
                xErrorMessage={false}
                xFullWidth={"100%"}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={1.8}
              sm={3.5}
              xs={6}
              className="bintransfer-data-date"
            >
              <CmpDatePicker
                xLabelText={"To Date"}
                xValue={vRdxFilterObj?.dateTo}
                xOnChange={(newValue) => {
                  dispatch(
                    FilterObj_Set({
                      dateTo: newValue.$d,
                    })
                  );
                }}
                xName={"dateTo"}
                xError={false}
                xErrorMessage={false}
                xFullWidth={"100%"}
              />
            </Grid>
            <Grid item lg={2} md={1.6} sm={3} xs={6}>
              <CmpSelectBox
                xLabelText="Status"
                xValue={
                  vRdxFilterObj?.statusVal == ""
                    ? statusData[0].id
                    : vRdxFilterObj?.statusVal
                }
                xOnChange={(e) => {
                  dispatch(
                    FilterObj_Set({
                      statusVal: e.target.value,
                    })
                  );
                }}
                xName={"statusVal"}
                xData={statusData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={false}
                xDisable={false}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={2.8}
              sm={5}
              xs={6}
              className="bintransfer-data-date"
            >
              <CmpTextFieldEnter
                xLabelText={"Doc.No"}
                xVariant={"outlined"}
                xValue={vRdxFilterObj?.DocNo}
                xOnChange={(e) => {
                  dispatch(
                    FilterObj_Set({
                      DocNo: e.target.value,
                    })
                  );
                }}
                xReadOnly={false}
                xType={"text"}
                xName={"DocNo"}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter") {
                    fLoad();
                  }
                }}
                xOnEnter={(e) => {
                  if (e.key === "Enter") {
                    fLoad();
                  }
                }}
                xSmShow={!!vMediaQuery}
              />
            </Grid>
            <Grid
              item
              lg={1.5}
              md={1}
              sm={4}
              xs={12}
              textAlign={"right"}
              className="bintransfet-data-load-btn"
            >
              <CmpButton
                xbtnName="Load"
                xOnClick={fLoad}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        )}

        <CustomDatagrid
          columns={visibleColumns}
          rows={sPackingGridRow}
          dense={true}
          showFilters={true}
          initialPageSize={10}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          onRowClick={(item) => {
            dispatch(
              PickingHead_Set({
                PickingHead: {
                  VocTyp: item?.A_VocTyp,
                  VocTypName: item?.VocName,
                  VocNo: item?.A_VocNo,
                  PostDate: item?.A_VocDt,
                  FromDate: item?.A_FromDt,
                  ToDate: item?.A_ToDate,
                  TransactionTypeCd: item?.A_TransTyp,
                  TransactionType: item?.A_TransTypName,
                  ClusterCd: item?.A_Cluster,
                  Cluster: item?.ClusterName,
                  LoadingBayCd: item?.A_LDBAY,
                  LoadingBay: item?.LDBAYName,
                  TypeCd: item?.A_Typ,
                  Type: (item?.A_Typ).toUpperCase() === "M" ? "Manual" : "Auto",
                  Loc: item?.A_Loc,
                  LocName: item?.LocName,
                  DocStatus: item?.A_DocStat,
                  Status: item?.A_PKL_DocStatus,
                },
              })
            );
            //navigate("/PickingPendingList");

            //detailObj for pickingPendingList (make resuable) by Ramesh Sir on Dec 26 2025
            navigate("/PickingPendingList", {
              //detailObj
              state: {
                entrySource: "Picking",
                current: "PickingPendingList",
                A_VocTyp: item?.A_VocTyp,
                VocName: item?.VocName,
                A_VocNo: item?.A_VocNo,
                A_Loc: item?.A_Loc,
                A_Typ: item?.A_Typ?.charAt(0),
                A_PKL_DocStatus: item?.A_PKL_DocStatus,
                A_DocStat: item?.A_DocStat,
                LoadingBayCode: item?.A_LDBAY,
                LoadingBayName: item?.LDBAYName,
              },
            });

            // navigate("/PickingPendingList");
          }}
          onSelectionChange={(ids, selectedRows) =>
            console.log(ids, selectedRows)
          }
          height={{
            xs: showPagination ? "65vh" : "72vh",
            sm: showPagination ? "49vh" : "58vh",
            md: showPagination ? "51vh" : "60vh",
            lg: showPagination ? "55.5vh" : "65vh",
            xl: showPagination ? "58vh" : "68vh",
          }}
        />
      </Box>
      {vMediaQuery && (
        <GCSummaryModal
          xOpen={showModal}
          fCloseModal={() => {
            setShowModal(false);
          }}
          xTitle="Filter"
          component={
            <>
              <Grid container spacing={2} className="stock-detail">
                <Grid
                  item
                  // lg={2} md={4}
                  xs={6}
                >
                  <CmpSelectBox
                    xref={LocationFocusOnLoad}
                    xLabelText="Location"
                    xValue={
                      vRdxFilterObj?.loc === ""
                        ? vRdxuserLoc[0]?.UID
                        : vRdxFilterObj?.loc
                    }
                    xOnChange={(e) => {
                      dispatch(
                        FilterObj_Set({
                          loc: e.target.value,
                        })
                      );
                    }}
                    xName={"loc"}
                    xData={sLocation}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={6}
                  className="bintransfer-data-date"
                >
                  <CmpDatePicker
                    xLabelText={"From"}
                    xValue={vRdxFilterObj?.dateFrom}
                    xOnChange={(newValue) => {
                      dispatch(
                        FilterObj_Set({
                          dateFrom: newValue.$d,
                        })
                      );
                    }}
                    xName={"dateFrom"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={6}
                  className="bintransfer-data-date"
                >
                  <CmpDatePicker
                    xLabelText={"To"}
                    xValue={vRdxFilterObj?.dateTo}
                    xOnChange={(newValue) => {
                      dispatch(
                        FilterObj_Set({
                          dateTo: newValue.$d,
                        })
                      );
                    }}
                    xName={"dateTo"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={6}
                >
                  <CmpSelectBox
                    xLabelText="Status"
                    xValue={
                      vRdxFilterObj?.statusVal == ""
                        ? statusData[0].id
                        : vRdxFilterObj?.statusVal
                    }
                    xOnChange={(e) => {
                      dispatch(
                        FilterObj_Set({
                          statusVal: e.target.value,
                        })
                      );
                    }}
                    xName={"statusVal"}
                    xData={statusData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2} md={4}
                  xs={12}
                  className="bintransfer-data-date"
                >
                  <CmpTextFieldEnter
                    xLabelText={"Doc.No"}
                    xVariant={"outlined"}
                    xValue={vRdxFilterObj?.DocNo}
                    xOnChange={(e) => {
                      dispatch(
                        FilterObj_Set({
                          DocNo: e.target.value,
                        })
                      );
                    }}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"DocNo"}
                    xOnKeyUp={(e) => {
                      if (e.key === "Enter") {
                        fLoad();
                      }
                    }}
                    xOnEnter={(e) => {
                      if (e.key === "Enter") {
                        fLoad();
                      }
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid
                  item
                  // lg={2}
                  // md={4}
                  xs={12}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpButton
                    xbtnName="Load"
                    xOnClick={fLoad}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </>
          }
        />
      )}
    </div>
  );
}
